import { Action } from "redux"

export const REQUEST_LOGO = "AUTH_REQUEST_LOGO"
export const RECEIVE_LOGO = "AUTH_RECEIVE_LOGO"
export const RECEIVE_RESTORE_PASSWORD_ERROR =
    "AUTH_RECEIVE_RESTORE_PASSWORD_ERROR"
export const RECEIVE_RESTORE_PASSWORD_SUCCESS =
    "AUTH_RECEIVE_RESTORE_PASSWORD_SUCCESS"
export const REQUEST_RESTORE_PASSWORD = "AUTH_REQUEST_RESTORE_PASSWORD"

export const RECEIVE_DATABASE_VERSION_ERROR =
    "AUTH_RECEIVE_DATABASE_VERSION_ERROR"
export const RECEIVE_DATABASE_VERSION_SUCCESS =
    "AUTH_RECEIVE_DATABASE_VERSION_SUCCESS"
export const REQUEST_DATABASE_VERSION = "AUTH_REQUEST_DATABASE_VERSION"
export const RECEIVE_MAINTENANCE_ERROR = "AUTH_RECEIVE_MAINTENANCE_ERROR"
export const RECEIVE_MAINTENANCE_SUCCESS = "AUTH_RECEIVE_MAINTENANCE_SUCCESS"
export const REQUEST_MAINTENANCE = "AUTH_REQUEST_MAINTENANCE"
export const RECEIVE_LOGIN_ERROR = "AUTH_RECEIVE_LOGIN_ERROR"
export const REQUEST_LOGIN = "AUTH_REQUEST_LOGIN"

export interface ReceiveError extends Action {
    errorMessage: string
}

export interface ReceiveLogo extends Action {
    logoUrl: string
}

export interface RequestLogin extends Action {
    username: string
    password: string
    remember: boolean
}

export interface RequestRestorePassword extends Action {
    email: string
}

export const receiveLogo = (logoUrl: string): ReceiveLogo => ({
    type: RECEIVE_LOGO,
    logoUrl,
})

export const requestLogo = (): Action => ({ type: REQUEST_LOGO })

export const receiveDatabaseVersionError = (
    errorMessage: string,
): ReceiveError => ({ type: RECEIVE_DATABASE_VERSION_ERROR, errorMessage })

export const receiveDatabaseVersionSuccess = (): Action => ({
    type: RECEIVE_DATABASE_VERSION_SUCCESS,
})

export const requestDatabaseVersion = (): Action => ({
    type: REQUEST_DATABASE_VERSION,
})

export const receiveMaintenanceError = (
    errorMessage: string,
): ReceiveError => ({ type: RECEIVE_MAINTENANCE_ERROR, errorMessage })

export const receiveMaintenanceSuccess = (): Action => ({
    type: RECEIVE_MAINTENANCE_SUCCESS,
})

export const requestMaintenance = (): Action => ({ type: REQUEST_MAINTENANCE })

export const receiveLoginError = (errorMessage: string): ReceiveError => ({
    type: RECEIVE_LOGIN_ERROR,
    errorMessage,
})

export const requestLogin = (
    username: string,
    password: string,
    remember: boolean,
): RequestLogin => ({ type: REQUEST_LOGIN, username, password, remember })

export const RECEIVE_LOGOUT_ERROR = "AUTH_RECEIVE_LOGOUT_ERROR"
export const REQUEST_LOGOUT = "AUTH_REQUEST_LOGOUT"

export const receiveLogoutError = (errorMessage: string): ReceiveError => ({
    type: RECEIVE_LOGOUT_ERROR,
    errorMessage,
})

export const requestLogout = (): Action => ({ type: REQUEST_LOGOUT })

export const receiveRestorePasswordSuccess = (): Action => ({
    type: RECEIVE_RESTORE_PASSWORD_SUCCESS,
})

export const receiveRestorePasswordError = (
    errorMessage: string,
): ReceiveError => ({ type: RECEIVE_RESTORE_PASSWORD_ERROR, errorMessage })

export const requestRestorePassword = (
    email: string,
): RequestRestorePassword => ({ type: REQUEST_RESTORE_PASSWORD, email })

export const mapDispatchToProps = {
    receiveLogo,
    requestLogo,
    receiveDatabaseVersionError,
    receiveDatabaseVersionSuccess,
    requestDatabaseVersion,
    receiveMaintenanceError,
    receiveMaintenanceSuccess,
    requestMaintenance,
    receiveLoginError,
    requestLogin,
    receiveLogoutError,
    requestLogout,
    receiveRestorePasswordError,
    receiveRestorePasswordSuccess,
    requestRestorePassword,
}

export type DispatchProps = typeof mapDispatchToProps
